import {Injectable} from '@angular/core';
import {Http, Headers, RequestOptions, Response} from '@angular/http';

import {Permission} from './permission';

@Injectable()
export class PermissionService {

  constructor(private http: Http) {

  }

  getAll(page: number = 1, sort: string = '') {
    let currentfilter = JSON.parse(localStorage.getItem('filter'));
    if(!currentfilter) {
      currentfilter = {};
    }

    const params = new URLSearchParams();
    params.set('page',  page+'');
    params.set('sorts', sort);
    for (let key in currentfilter) {
      if(currentfilter[key]) {
        params.set('filter[' + key + ']', currentfilter[key])
      }
    }
    return this.http.get('permissions?' + params.toString()).map((response: Response) => response.json());
  }


  getAll_screens() {
    return this.http.get('permissions/allscreens').map((response: Response) => response.json());
  }
  getById(_id: string) {
    return this.http.get('permissions/' + _id).map((response: Response) => response.json());
  }
  getTrashedById(_id: string) {
    return this.http.get('permissions/trashed/' + _id).map((response: Response) => response.json());
  }
  restoreTrashedById(_id: string) {
    return this.http.put('permissions/trashed/' + _id,{}).map((response: Response) => response.json());
  }

  create(permission: Permission) {
    return this.http.post('permissions', permission).map((response: Response) => response.json());
  }

  update(permission: Permission) {
    return this.http.put('permissions/' + permission.id, permission).map((response: Response) => response.json());
  }

  getAllPermission() {
    return this.http.get('permissions/all').map((response: Response) => response.json());
  }

  delete(_id: string) {
    return this.http.delete('permissions/' + _id).map((response: Response) => response.json());
  }
}



// WEBPACK FOOTER //
// ./src/app/views/setting/permissions/permission.service.ts